<div class="layout-table-container">
  <div class="attribute-editor-component">
    <div class="layout-table-tabs" role="tablist" aria-label="List settings">
      @for (tab of settingsTabs; track tab.id) {
        <button
          type="button"
          class="layout-table-tabs__tab"
          [class.layout-table-tabs__tab--active]="activeSettingsTab === tab.id"
          role="tab"
          [id]="getSettingsTabId(tab.id)"
          [attr.aria-selected]="activeSettingsTab === tab.id"
          [attr.aria-controls]="getSettingsTabPanelId(tab.id)"
          [attr.tabindex]="activeSettingsTab === tab.id ? 0 : -1"
          (click)="selectSettingsTab(tab.id)"
          (keydown)="onSettingsTabKeydown($event, tab.id)"
        >
          {{ tab.label }}
        </button>
      }
    </div>

    <div
      class="scrollable-component-settings te-scrollable-container layout-table-settings"
    >
      @if (activeSettingsTab === 'layout') {
        <div
          role="tabpanel"
          [id]="getSettingsTabPanelId('layout')"
          [attr.aria-labelledby]="getSettingsTabId('layout')"
        >
          <!-- Choose Layout — hidden until all layouts are ready -->
          <div class="attribute-editor-row">
            <label id="layout-table-layout-label">Choose Layout</label>
            <div class="form-group layout-selector">
              <div
                class="layout-container"
                role="radiogroup"
                aria-labelledby="layout-table-layout-label"
              >
                <button
                  #layoutOptionBtn
                  type="button"
                  class="layout-option"
                  [ngClass]="{
                    'layout-option--selected': layout === LayoutType.CARD_GRID,
                  }"
                  (click)="setLayout(LayoutType.CARD_GRID)"
                  (keydown)="onLayoutKeydown($event, LayoutType.CARD_GRID)"
                  [attr.aria-checked]="layout === LayoutType.CARD_GRID"
                  [attr.tabindex]="
                    layout === LayoutType.CARD_GRID || !layout ? 0 : -1
                  "
                  role="radio"
                >
                  <div class="layout-icon-container">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 64 64"
                      fill="none"
                      overflow="visible"
                      aria-hidden="true"
                    >
                      <rect
                        x="7"
                        y="7"
                        width="24"
                        height="24"
                        rx="2"
                        fill="white"
                        stroke="rgba(57,76,96,0.03)"
                        stroke-width="0.5"
                      />
                      <rect
                        x="7"
                        y="7"
                        width="24"
                        height="12"
                        rx="4"
                        fill="#3BBF74"
                      />
                      <rect
                        x="33"
                        y="7"
                        width="24"
                        height="24"
                        rx="2"
                        fill="white"
                        stroke="rgba(57,76,96,0.03)"
                        stroke-width="0.5"
                      />
                      <rect
                        x="33"
                        y="7"
                        width="24"
                        height="12"
                        rx="4"
                        fill="#3BBF74"
                      />
                      <rect
                        x="7"
                        y="33"
                        width="24"
                        height="24"
                        rx="2"
                        fill="white"
                        stroke="rgba(57,76,96,0.03)"
                        stroke-width="0.5"
                      />
                      <rect
                        x="7"
                        y="33"
                        width="24"
                        height="12"
                        rx="4"
                        fill="#3BBF74"
                      />
                      <rect
                        x="33"
                        y="33"
                        width="24"
                        height="24"
                        rx="2"
                        fill="white"
                        stroke="rgba(57,76,96,0.03)"
                        stroke-width="0.5"
                      />
                      <rect
                        x="33"
                        y="33"
                        width="24"
                        height="12"
                        rx="4"
                        fill="#3BBF74"
                      />
                    </svg>
                  </div>
                  <div class="layout-label">Card grid</div>
                </button>

                <button
                  #layoutOptionBtn
                  type="button"
                  class="layout-option"
                  [ngClass]="{
                    'layout-option--selected': layout === LayoutType.SINGLE,
                  }"
                  (click)="setLayout(LayoutType.SINGLE)"
                  (keydown)="onLayoutKeydown($event, LayoutType.SINGLE)"
                  [attr.aria-checked]="layout === LayoutType.SINGLE"
                  [attr.tabindex]="layout === LayoutType.SINGLE ? 0 : -1"
                  role="radio"
                >
                  <div class="layout-icon-container">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 64 64"
                      fill="none"
                      overflow="visible"
                      aria-hidden="true"
                    >
                      <defs>
                        <filter
                          id="layout-table-single-shadow"
                          x="-30%"
                          y="-30%"
                          width="160%"
                          height="160%"
                        >
                          <feDropShadow
                            dx="0"
                            dy="2"
                            stdDeviation="3"
                            flood-color="#94A3B8"
                            flood-opacity="0.2"
                          />
                          <feDropShadow
                            dx="0"
                            dy="2"
                            stdDeviation="2"
                            flood-color="#94A3B8"
                            flood-opacity="0.2"
                          />
                        </filter>
                      </defs>
                      <rect
                        x="0"
                        y="17.5"
                        width="64"
                        height="16"
                        rx="2"
                        fill="white"
                      />
                      <rect
                        x="0"
                        y="17.5"
                        width="64"
                        height="28"
                        rx="2"
                        fill="white"
                        stroke="rgba(57,76,96,0.03)"
                        stroke-width="0.5"
                        filter="url(#layout-table-single-shadow)"
                      />
                      <rect
                        x="22"
                        y="22.5"
                        width="36"
                        height="4"
                        rx="2"
                        fill="#E2E8F0"
                      />
                      <rect
                        x="3"
                        y="20.5"
                        width="16"
                        height="22"
                        rx="2"
                        fill="#3BBF74"
                      />
                    </svg>
                  </div>
                  <div class="layout-label">Single</div>
                </button>

                <button
                  #layoutOptionBtn
                  type="button"
                  class="layout-option"
                  [ngClass]="{
                    'layout-option--selected': layout === LayoutType.TABLE,
                  }"
                  (click)="setLayout(LayoutType.TABLE)"
                  (keydown)="onLayoutKeydown($event, LayoutType.TABLE)"
                  [attr.aria-checked]="layout === LayoutType.TABLE"
                  [attr.tabindex]="layout === LayoutType.TABLE ? 0 : -1"
                  role="radio"
                >
                  <div class="layout-icon-container">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 64 64"
                      fill="none"
                      overflow="visible"
                      aria-hidden="true"
                    >
                      <rect
                        x="0"
                        y="8.5"
                        width="64"
                        height="46"
                        rx="2"
                        fill="white"
                        stroke="rgba(57,76,96,0.03)"
                        stroke-width="0.5"
                      />
                      <rect
                        x="0"
                        y="15.5"
                        width="64"
                        height="13"
                        fill="#F1F5F9"
                      />
                      <rect
                        x="3"
                        y="18.5"
                        width="9"
                        height="7"
                        rx="2"
                        fill="#3BBF74"
                      />
                      <rect
                        x="3"
                        y="31.5"
                        width="9"
                        height="7"
                        rx="2"
                        fill="#3BBF74"
                      />
                      <rect
                        x="0"
                        y="41.5"
                        width="64"
                        height="13"
                        rx="2"
                        fill="#F1F5F9"
                      />
                      <rect
                        x="3"
                        y="44.5"
                        width="9"
                        height="7"
                        rx="2"
                        fill="#3BBF74"
                      />
                    </svg>
                  </div>
                  <div class="layout-label">Table</div>
                </button>
              </div>
            </div>
          </div>

          @if (layout === LayoutType.CARD_GRID) {
            <div class="attribute-editor-row">
              <div class="form-group">
                <div class="flex-row left-right-aligner">
                  <label for="te-layout-table-columns">Columns</label>
                  <select
                    id="te-layout-table-columns"
                    name="te-layout-table-columns"
                    class="form-control layout-table-select"
                    [(ngModel)]="columns"
                    (ngModelChange)="saveLayout()"
                    aria-label="Columns"
                  >
                    @for (
                      option of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
                      track option
                    ) {
                      <option [ngValue]="option">{{ option }}</option>
                    }
                  </select>
                </div>
              </div>
            </div>
          }

          @if (layout === LayoutType.CARD_GRID || layout === LayoutType.TABLE) {
            <div class="attribute-editor-row">
              <div class="form-group">
                <div class="flex-row left-right-aligner">
                  <label for="te-layout-table-scroll-speed">Scroll speed</label>
                  <select
                    id="te-layout-table-scroll-speed"
                    name="te-layout-table-scroll-speed"
                    class="form-control layout-table-select"
                    [(ngModel)]="scrollSpeed"
                    (ngModelChange)="saveLayout()"
                    aria-label="Scroll speed"
                  >
                    @for (option of scrollSpeedOptions; track option.value) {
                      <option [ngValue]="option.value">
                        {{ option.label }}
                      </option>
                    }
                  </select>
                </div>
              </div>
            </div>
          }

          @if (layout === LayoutType.SINGLE) {
            <div class="attribute-editor-row">
              <div class="form-group">
                <div class="flex-row left-right-aligner">
                  <label for="te-layout-table-slide-duration"
                    >Show each item for</label
                  >
                  <div class="input-group layout-table-input-group">
                    <input
                      type="number"
                      id="te-layout-table-slide-duration"
                      name="te-layout-table-slide-duration"
                      class="form-control"
                      min="1"
                      [(ngModel)]="slideDuration"
                      (change)="saveLayout()"
                      aria-label="Show each item for (seconds)"
                    />
                    <span class="input-group-addon">Seconds</span>
                  </div>
                </div>
              </div>
            </div>
          }

          @if (layout === LayoutType.TABLE) {
            <div class="attribute-editor-row">
              <div class="flex-row left-right-aligner pt-3 pb-3 form-group">
                <label id="layout-table-show-table-headers-label"
                  >Show table headers</label
                >
                <mat-slide-toggle
                  class="pl-3"
                  [checked]="showTableHeaders"
                  (change)="showTableHeaders = $event.checked; saveLayout()"
                  ariaLabelledby="layout-table-show-table-headers-label"
                ></mat-slide-toggle>
              </div>
            </div>
          }

          <div class="attribute-editor-row tw-mt-[20px]">
            <p class="layout-table-section-heading">Colors</p>
            <div class="form-group">
              <div class="flex-row left-right-aligner pt-3">
                <span
                  id="layout-table-color-label-text"
                  class="layout-table-color-label"
                  >Text</span
                >
                <color-picker
                  pickerId="te-layout-table-text-color"
                  ariaLabelledby="layout-table-color-label-text"
                  [(ngModel)]="textColor"
                  (change)="saveLayout()"
                  ngDefaultControl
                ></color-picker>
              </div>
            </div>
            <div class="form-group">
              <div class="flex-row left-right-aligner pt-3">
                <span
                  id="layout-table-color-label-accent"
                  class="layout-table-color-label"
                  >Accent</span
                >
                <color-picker
                  pickerId="te-layout-table-accent-color"
                  ariaLabelledby="layout-table-color-label-accent"
                  [(ngModel)]="accentColor"
                  (change)="saveLayout()"
                  ngDefaultControl
                ></color-picker>
              </div>
            </div>
            <div class="form-group">
              <div class="flex-row left-right-aligner pt-3">
                <span
                  id="layout-table-color-label-bg"
                  class="layout-table-color-label"
                  >Background</span
                >
                <color-picker
                  pickerId="te-layout-table-bg-color"
                  ariaLabelledby="layout-table-color-label-bg"
                  [(ngModel)]="backgroundColor"
                  (change)="saveLayout()"
                  ngDefaultControl
                ></color-picker>
              </div>
            </div>
          </div>
        </div>
      }

      @if (activeSettingsTab === 'content-data') {
        <div
          role="tabpanel"
          [id]="getSettingsTabPanelId('content-data')"
          [attr.aria-labelledby]="getSettingsTabId('content-data')"
        >
          <data-table-content-editor
            #contentEditor
            [componentId]="componentId"
            idPrefix="layout-table"
            [canDefineFields]="true"
            [loadContent]="loadContentData"
            [saveContent]="saveContentData"
          ></data-table-content-editor>
        </div>
      }
    </div>
  </div>
</div>
